<template>
  <div class="ds-control ds-form-item ds-code-set" :class="getCss">
    <template v-if="simple && readOnly && !isDesign">
      <DsfTextProxy v-model="selectValue" v-bind="_self.$props"></DsfTextProxy>
      <slot name="error">
        <div v-if="errors.length > 0" class="ds-error-text">
          {{ errorsMsg }}
        </div>
      </slot>
    </template>
    <template v-else>
      <DsfFieldLabel
        v-if="showLabel"
        :mode="showDataCaptionMode"
        :style="getLabelWidthStyle()"
        :show-icon="showDataCaptionIcon"
        :trigger="showDataCaptionTrigger"
        :data-caption="dataCapion"
        :is-design="isDesign"
        :owner="_self"
      >
        {{ $t(label) }}
      </DsfFieldLabel>
      <div class="ds-form-block" :style="getFormItemBlockMarginLeft()">
        <div
          class="ds-code-set-default"
          v-if="!readOnly"
          @click.stop="clickHandler"
        >
          <el-input
            :placeholder="placeholder"
            :readonly="true"
            v-model="selectValue"
            :disabled="disabled"
            :clearable="clearable"
            :class="{ 'hidden-border': !showBorder }"
          >
            <i
              ref="icon_arrow_down"
              v-if="!clearable || !selectValue"
              slot="suffix"
              class="el-input__icon el-icon-arrow-down"
            ></i>
            <template v-else>
              <i
                @click.stop="clear"
                slot="suffix"
                class="el-input__icon el-icon-circle-close clearable-close"
              ></i>
              <i
                slot="suffix"
                class="el-input__icon el-icon-arrow-down clearable-arrowdown"
              ></i>
            </template>
          </el-input>
        </div>
        <div v-else-if="readOnly" class="ds-form-readonly">
          <DsfTextProxy
            v-model="selectValue"
            v-bind="_self.$props"
            :show-label="false"
          ></DsfTextProxy>
        </div>
        <slot name="error">
          <div v-if="errors.length" class="ds-error-text">{{ errorsMsg }}</div>
        </slot>
      </div>
    </template>
  </div>
</template>

<script>
export default dsf.component({
  name: "DsfAreaSelectDialog",
  ctrlCaption: "级联选择弹窗版",
  mixins: [$mixins.control, $mixins.formControl],
  props: {
    // 值
    value: {
      type: [Object, Array],
      required: false,
    },
    // 选项
    items: {
      type: Array,
      default() {
        return [];
      },
    },
    placeholder: {
      type: String,
      default: "请选择",
    },
    // 是否为行政区划
    areaselect: {
      type: Boolean,
      default: false,
    },
    // 是否自定义接口
    iszdyjk: {
      type: Boolean,
      default: true,
    },
    // 是否开启懒加载
    isLazy: {
      type: Boolean,
      default: true,
    },
    // 自定义接口地址
    initDataSourceUrl: {
      type: String,
      default: "",
    },
    // 异步自定义接口地址
    lazyUrl: {
      type: String,
      default: "",
    },
    // 异步自定义子节点接口地址
    lazyChildrenUrl: {
      type: String,
      default: "",
    },
    // 异步自定义搜索接口地址
    lazySearchUrl: {
      type: String,
      default: "",
    },
    // 根节点数据
    pid: {
      type: String,
      default: "",
    },

    /* -------   组件属性   ------- */
    // 是否支持清空选项
    clearable: {
      type: Boolean,
      default: true,
    },
    // 是否显示完整路径
    showAllLevels: {
      type: Boolean,
      default: false,
    },
    // 路径分隔字符
    separator: {
      type: String,
      default: "/",
    },
    // 手风琴模式
    accordion: {
      type: Boolean,
      default: true,
    },

    /* -------   代码选择器弹窗属性   ------- */
    dialogconfig: {
      type: Object,
      default() {
        return {
          title: "",
          width: "600px",
          height: "60vh",
          top: "10vh",
          layout: "right",
          multiple: false,
          checkStrictly: true,
        };
      },
    },
    keysMap: {
      type: Array,
      default() {
        return [
          { from: "text", to: "text", type: "text", desc: "节点名称" },
          { from: "value", to: "value", type: "text", desc: "值" },
          { from: "pid", to: "pid", type: "number", desc: "节点父标识" },
          { from: "children", to: "children", type: "array", desc: "子节点" },
          { from: "level", to: "level", type: "number", desc: "层级" },
        ];
      },
    },
    // 元数据
    metadata: {
      type: Object,
      default() {
        return dsf.metadata.get("items-meta-data");
      },
    },
  },
  watch: {
    areaselect(n) {
      if (this.dialogconfig.multiple && n) this.dialogconfig.multiple = false;
    },
    value(n) {
      console.log(this.value);
      if (n) {
        this.initValue();
      }
    },
  },
  data() {
    return {
      selectValue: "",
    };
  },
  computed: {
    realItems() {
      if (this.isDesign) {
        return [];
      }
      return this.items || [];
    },
    multiple() {
      return this.dialogconfig.multiple;
    },
  },
  mounted() {
    if (this.value) {
      this.initValue();
    }
  },
  methods: {
    initValue() {
      if (dsf.isObject(this.value) && this.value?.text) {
        this.selectValue = this.value.text;
      } else if (dsf.isArray(this.value)) {
        _.forEach(this.value, it => {
          if (this.selectValue) this.selectValue += ",";
          this.selectValue += it?.text ? it.text : "";
        });
      }
    },
    clickHandler() {
      const _this = this;
      this.transformHandler("180deg");
      this.$openDialog({
        title: this.dialogconfig.title,
        content: "CodeSetDialog",
        width: this.dialogconfig.width,
        height: this.dialogconfig.height,
        footerAlign: this.dialogconfig.layout,
        top: this.dialogconfig.top,
        params: {
          $fnode: this,
        },
        btns: [
          {
            text: "保存",
            type: "main",
            handler(res) {
              let selectValue = [];
              if (_this.dialogconfig.multiple) {
                selectValue = res.$refs.tree.getCheckedNodes();
                if (!_this.dialogconfig.checkStrictly) {
                  selectValue = selectValue.filter((s) => !s.children);
                }
              } else {
                selectValue = res?.checkedNode || [];
              }

              if (selectValue.length > 0) {
                _this.transformHandler(0);

                let result = [];
                if (_this.iszdyjk) {
                  _.forEach(selectValue, (val) => {
                    result.push(val);
                  });
                } else {
                  _.forEach(selectValue, (val) => {
                    result.push(
                      _this.getValueByPath(
                        val.value,
                        _this.showAllLevels ? val?.fulltext : val.text
                      )
                    );
                  });
                }

                if (_this.dialogconfig.multiple) _this.emitValueChange(result);
                else _this.emitValueChange(...result);
              } else {
                _this.clear();
              }
            },
          },
          {
            text: "关闭",
            handler(res) {
              _this.transformHandler(0);
            },
          },
        ],
      });
    },
    getValueByPath(path, targetText) {
      path = _.cloneDeep(path);
      let items = this.realItems;
      if (items == null || !path) {
        return null;
      }

      let text = "",
        value = "";
      dsf.deepForEach(
        this.realItems,
        (item) => {
          let val = item[this.keysMap[1].from];
          if (path === val) {
            text = targetText;
            value = val;
            return -1;
          }
        },
        {
          children: this.keysMap[3].from,
        }
      );

      let res = {
        text: text,
        value,
      };
      return res;
    },
    clear() {
      this.selectValue = "";
      this.emitValueChange({});
    },
    transformHandler(deg) {
      if (this.$refs?.icon_arrow_down) {
        this.$refs.icon_arrow_down.style.transform = `rotate(${deg})`;
      }
    },
  },
  design: {
    layout: {
      exclude: ["value", "#items"],
    },
    settingMenus: [
      ...($mixins.formControl.design.settingMenus || []),
      {
        text: "选项设置",
        command: "datasource",
        handler() {
          dsf.designer.triggerDialogPropty("metadata.dataSource");
        },
      },
    ],
    metadata: {
      create(root) {
        let res = $mixins.formControl.design.metadata.create.call(this, root);
        let aliasIndex = _.findIndex(
          res.metadata.valueAttributes,
          (it) => it.code === "alias"
        );
        if (this.postHasAlias && aliasIndex === -1) {
          res.metadata.valueAttributes.push({
            name: "别名",
            code: "alias",
            type: dsf.metadata.getDataType("string"),
            length: 100,
            defaultValue: null,
            encrypt: false,
            unit: null,
          });
        } else if (!this.postHasAlias && aliasIndex > -1) {
          res.metadata.valueAttributes.splice(aliasIndex, 1);
        }
        return res;
      },
    },
  },
});
</script>
